/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        maxWidth: '1920px'
    },
    variants: {
        form: {
            maxWidth: {md: '522px'},
            px: 0
        }
    }
}
